import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectApiTokenService } from 'src/app/shared/services/project-api-token.service';
import { ProjectService } from 'src/app/shared/services/project.service';

export const projectApiTokenResolver: ResolveFn<boolean> = async (_route, _state) => {
  const apiTokenService = inject(ProjectApiTokenService);
  const projectService = inject(ProjectService);
  apiTokenService.selectedProjectId = projectService.selectedProject?._id ?? "";
  await apiTokenService.loadApiTokens();
  return true;
};
